import { ModalProps } from 'antd'
import { StyledModal } from 'styles/components/Modal'

const Modal = (props: ModalProps) => {
  return <StyledModal {...props} />
}

export default Modal
